export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8621.257d77c4.jpg";